import axios from 'CanExConfig/axios'

const endpoint = candidateProfileId => `/api/candidate/v2/candidate_profiles/${candidateProfileId}`

export const postHideCandidateProfile = async (candidateProfileId, data) => {
  const response = await axios(`${endpoint(candidateProfileId)}/hides`, {
    method: 'POST',
    data,
  })

  return response.data
}

export const reapplyProfile = async id => {
  const response = await axios(`/api/candidate/profiles/${id}/reapply`, {
    method: 'PUT',
  })

  return response.data.result
}
